// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-clock .clock-time[data-v-320a1f50] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
